export default {
  replySent:
    "Antwort gesendet! E-Mail-Benachrichtigung an den Verkäufer gesendet",
  internalNoteAdded: "Interne Notiz hinzugefügt",
  sendMessageError: "Nachricht konnte nicht gesendet werden",
  ticketMarked: "Ticket als {{label}} markiert",
  updateStatusError: "Status konnte nicht aktualisiert werden",
  priorityUpdated: "Priorität aktualisiert",
  updatePriorityError: "Priorität konnte nicht aktualisiert werden",
} as const;
